module.exports = __webpack_public_path__ + "img/keypal-color-2.9c5ef909.png";